<template>
  <article>
    <div class="dataForm">
      <div class="dataForm__item">
        <div class="dataForm__name">ID</div>
        <el-input v-model="detail.obid" placeholder="" size="mini" class="dataForm__input" :disabled="true"></el-input>
      </div>

      <div class="dataForm__item mt-20">
        <div class="dataForm__name">商品:</div>
        <el-select class="dataForm__input" v-model="detail.ibid" size="mini" :disabled="change">
          <el-option :value="item.ibid" :label="item.name" v-for="(item, index) in inboundList" :key="index"></el-option>
        </el-select>
      </div>
      <div class="dataForm__item mt-20">
        <div class="dataForm__name ml40">原价</div>
        <el-input v-model="detail.original_price" placeholder="" size="mini" class="dataForm__input" :disabled="true"></el-input>
      </div>
      <div class="dataForm__item mt-20">
        <div class="dataForm__name ml40">成本</div>
        <el-input v-model="detail.cost_price" placeholder="" size="mini" class="dataForm__input" :disabled="true"></el-input>
      </div>
      <div class="dataForm__item mt-20">
        <div class="dataForm__name ml40">剩余库存</div>
        <el-input v-model="detail.balance" placeholder="" size="mini" class="dataForm__input" :disabled="true"></el-input>
      </div>
      <div class="dataForm__item mt-20">
        <div class="dataForm__name ml40">销售数量</div>
        <el-input v-model="detail.sale_number" placeholder="" size="mini" class="dataForm__input" :disabled="change"></el-input>
      </div>
      <div class="dataForm__item mt-20">
        <div class="dataForm__name ml40">销售金额</div>
        <el-input v-model="detail.sale_amount" placeholder="" size="mini" class="dataForm__input" :disabled="change"></el-input>
      </div>
      <div class="dataForm__item mt-20">
        <div class="dataForm__name ml40">出单人</div>
        <el-input v-model="detail.saler" placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-20">
        <div class="dataForm__name ml40">快递单号</div>
        <el-input v-model="detail.delivery" placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-20">
        <div class="dataForm__name ml40">收件地址</div>
        <el-input v-model="detail.address" placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-20">
        <div class="dataForm__name ml40">收款记录</div>
        <el-input v-model="detail.sale_record" placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-20">
        <div class="dataForm__name ml40">备注</div>
        <el-input v-model="detail.remark" placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name"></div>
        <button class="blue-large-btn" @click="outboundEdit">保存</button>
      </div>
    </div>
  </article>
</template>

<script>
import util from '../../../script/util'
import {outboundDetail, outboundEdit, inboundLists} from '../../../api/api'
export default {
  name: 'outboundEdit',
  data () {
    return {
      detail: {
        obid: 0,
        ibid: '',
        original_price: '',
        cost_price: '',
        balance: '',
        sale_number: '',
        sale_account: '',
        profit: '',
        saler: '',
        delivery: '',
        address: '',
        sale_record: '',
        remark: ''
      },
      inboundList: [],
      change: false,
      dialog: false,
      categoryList: [
        {
          name: '正装',
          value: 0
        },
        {
          name: '小样',
          value: 1
        }
      ]
    }
  },
  methods: {
    getInboundList () {
      let params = {
        p: 1,
        l: 500
      }
      inboundLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.inboundList = data.d.lists
          data.d.lists.forEach(item => {
            if (item['balance'] !== 0) {
              item['name'] = item['commodity'] + '(' + item['ibid'] + ')' + '(库存:' + item['balance'] + ')'
              this.inboundList.push(item)
            }
          })
          this.detail.ibid = parseInt(this.$route.query.ibid || 0)
          if (this.detail.ibid) {
            this.inboundChange()
          }
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      }).catch(() => {
        this.notifyError('服务器出错了')
      })
    },
    // 公众号详情
    outboundDetail () {
      let params = {
        obid: this.detail.obid
      }
      this.loading = true
      outboundDetail(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.detail = data.d.outbound
        } else {
          this.$notify({
            title: '失败',
            message: '服务器出错了',
            type: 'error'
          })
        }
        this.loading = false
      })
    },
    outboundEdit () {
      let content = ''

      if (this.detail.sale_record === '') {
        content = '请填写收款记录'
      }

      if (content) {
        this.$notify({
          title: '失败',
          message: content,
          type: 'error'
        })
        return
      }

      let params = util.cloneObj(this.detail)
      outboundEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
          this.$router.push('/outboundList')
        } else {
          this.$notify({
            title: '失败',
            message: '服务器出错了',
            type: 'error'
          })
        }
      })
    },
    inboundChange () {
      this.inboundList.forEach(item => {
        if (this.detail.ibid === item.ibid) {
          this.detail.original_price = item.original_price
          this.detail.cost_price = item.cost_price
          this.detail.balance = item.balance
        }
      })
    }
  },
  watch: {
    'detail.ibid': 'inboundChange'
  },
  mounted () {
    this.detail.obid = parseInt(this.$route.query.obid || 0)
    if (this.detail.obid) {
      this.change = true
      this.outboundDetail()
    }
    this.getInboundList()
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/stock/outboundEdit.vue